mutation RemoveSecondFactors($userId: ID!, $code: String!) {
  removeSecondFactors(input: { userId: $userId, code: $code }) {
    success
  }
}
